import React from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';

import {
  LoginPage,
  Dashboard,
  BrandsPage,
  UsersPage,
  StoresPage,
  PublicPage,
} from 'components';

//TODO: Remove this function from here
function isAuthenticatedUser() {
  return localStorage.getItem('@token');
}

export function Routes(props) {

  const PrivateRoute = ({ component: Component, ...properties }) => (
    <Route
      {...properties}
      render={(props) => {
        return isAuthenticatedUser() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        );
      }}
    />
  );

  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" component={() => <PublicPage />} />
        <Route exact path="/(ac|al|ap|am|ba|ce|df|es|go|ma|mt|ms|mg|pa|pb|pr|pe|pi|rj|rn|rs|ro|rr|sc|sp|se|to)/" component={() => <PublicPage />} />
        <Route path="/login" component={() => <LoginPage />} />
        <PrivateRoute path="/dashboard" component={() => <Dashboard />} />
        <PrivateRoute path="/marcas" component={() => <BrandsPage />} />
        <PrivateRoute path="/usuarios" component={() => <UsersPage />} />
        <PrivateRoute path="/lojas" component={() => <StoresPage />} />
        <Route path="*" exact={true} component={() => <PublicPage />} />
      </Switch>
    </HashRouter>
  );
}
